<!-- review-order-modal.component.html -->
<div class="avaliar-vendedor">
  <h2 mat-dialog-title class="avaliar-vendedor__titulo">
    Avaliar Vendedor
    <button mat-icon-button mat-dialog-close class="avaliar-vendedor__fechar" aria-label="Fechar">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="avaliar-vendedor__conteudo">
    <div class="avaliar-vendedor__corpo">

      <!-- Coluna esquerda: ficha do vendedor. Nome chega na hora (fallback do
           caller); foto/localização/nota completam quando sellers/v1 responde. -->
      <div class="avaliar-vendedor__ficha">
        <div class="avaliar-vendedor__avatar">
          <img *ngIf="ficha?.profilePhoto" [src]="ficha.profilePhoto" [alt]="vendorName || 'Vendedor'"
            class="avaliar-vendedor__avatar-foto">
          <mat-icon *ngIf="!ficha?.profilePhoto" class="avaliar-vendedor__avatar-placeholder" aria-hidden="true">
            person
          </mat-icon>
        </div>

        <p class="avaliar-vendedor__nome">{{ vendorName || 'Vendedor' }}</p>

        <p class="avaliar-vendedor__localizacao" *ngIf="ficha?.location">
          <mat-icon aria-hidden="true">place</mat-icon>
          <span>{{ ficha.location }}</span>
        </p>

        <div class="avaliar-vendedor__nota" *ngIf="ficha">
          <span class="avaliar-vendedor__nota-valor">{{ ficha.averageRating | number: '1.1-1' }}</span>
          <div class="avaliar-vendedor__nota-estrelas" aria-hidden="true">
            <mat-icon *ngFor="let cheia of estrelasDaFicha(ficha.averageRating)">
              {{ cheia ? 'star' : 'star_border' }}
            </mat-icon>
          </div>
          <span class="avaliar-vendedor__nota-contagem">
            ({{ ficha.totalReviews }} {{ ficha.totalReviews === 1 ? 'avaliação' : 'avaliações' }})
          </span>
        </div>

        <div class="avaliar-vendedor__ficha-esqueleto" *ngIf="fichaCarregando" aria-hidden="true">
          <span class="avaliar-vendedor__esqueleto-linha"></span>
          <span class="avaliar-vendedor__esqueleto-linha avaliar-vendedor__esqueleto-linha--curta"></span>
        </div>
      </div>

      <!-- Coluna direita: formulário (mesmo escopo de sempre — nota + comentário). -->
      <div class="avaliar-vendedor__formulario">
        <div class="avaliar-vendedor__estrelas" role="radiogroup" aria-label="Nota do vendedor, de 1 a 5 estrelas">
          <button type="button" *ngFor="let star of stars; let i = index" class="avaliar-vendedor__estrela"
            [class.avaliar-vendedor__estrela--preenchida]="star" (click)="rate(i + 1)" role="radio"
            [attr.aria-checked]="star" [attr.aria-label]="'Avaliar com ' + (i + 1) + ' estrela(s)'">
            <mat-icon>{{ star ? 'star' : 'star_border' }}</mat-icon>
          </button>
        </div>

        <div class="avaliar-vendedor__descricao">
          <span *ngIf="currentRatingDescription">{{ currentRatingDescription | transloco }}</span>
        </div>

        <mat-form-field appearance="outline" class="avaliar-vendedor__campo">
          <mat-label>Avaliação</mat-label>
          <textarea rows="4" matInput [(ngModel)]="reviewText"></textarea>
        </mat-form-field>
      </div>

    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="avaliar-vendedor__acoes">
    <button type="button" mat-dialog-close class="avaliar-vendedor__cancelar">{{ 'cancelar' | transloco }}</button>
    <button type="button" class="avaliar-vendedor__enviar" [disabled]="isSubmitDisabled()" (click)="submitReview()">
      Enviar Avaliação
    </button>
  </mat-dialog-actions>
</div>
